<template>
  <div style="width:1366px;height: 100%;margin: 40px auto">
    <el-tabs :tab-position="tabPosition" class="infoShow">
      <el-tab-pane class="tabName" label="设计实力">
        <design-ability></design-ability>
      </el-tab-pane>
      <el-tab-pane class="tabName" label="制造实力">
        <produce-ability></produce-ability>
      </el-tab-pane>
      <el-tab-pane class="tabName" label="科研实力">
        <s-r_ability></s-r_ability>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
    import designAbility from './Components/designAbility'
    import produceAbility from './Components/produceAbility'
    import SR_ability from './Components/SRability'

    export default {
        data() {
            return {
                tabPosition: 'left'
            };
        },
        components: {
            designAbility,
            produceAbility,
            SR_ability
        }
    };

</script>

<style scoped>
  .el-tabs--left {
    height: 720px;
    margin: 0 10px;
  }

  .el-tabs--left >>> .el-tabs__item.is-left{
    text-align: center;
  }

  .el-tabs--left >>> .el-tabs__item {
    font-size: 20px;
    margin: 15px auto;
    padding: 0;

    width: 160px;
    height: 60px;
    line-height: 60px;
  }

  .el-tabs--left >>> .el-tabs__header {
    width: 180px;
    margin-right: 30px;
  }

  .el-tabs--left >>> .el-tabs__nav {
    margin-top: 50px;
  }

  .el-tabs--left >>> .el-tabs__item.is-active {
    width: 156px;
    color: #fff;
    background: #144685;
    box-shadow: -3px 3px 3px #103768;
    border-radius: 0 15px 0 15px;
    margin: auto;
  }

  .el-tabs--left >>> .el-tabs__active-bar {
    width: 0;
    height: 0;
  }


  .el-tabs--left >>> .el-tabs__active-bar.is-left{
    width: 0;
    height: 0;
  }

  .el-tabs--left >>> .el-tabs__nav-wrap.is-left::after {
    width: 4px;
    background-color: #CECECE;
  }

  ul {
    padding: 0;
    text-align: center;
    list-style: none
  }
</style>



// WEBPACK FOOTER //
// src/pages/Technology/technologyInfo.vue